import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import DeleteRecord from 'src/lib/api/DeleteRecord';
import GetRecords from 'src/lib/api/GetRecords';
import { APIS } from 'src/lib/constants/apis';
import {
	ALS_ERLEDIGT_MARKIEREN_LABEL,
	ERLAUTERUNG_IN_KOSTEN_TITLE,
	KOSTEN_POSITION,
	KOSTENTRAEGER,
	PLATZHALTER_TEXT,
} from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkIfSpecificKostenPositionHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { withKostenkategorieEinsatzbereichFilter } from 'src/utils/einsatzbereichHelper';
import { getFormStrucComponentTable } from 'src/utils/formStruc';
import { addIndexesToPath, checkReadOnlyInUeberarbeitung, enumT, getOptionsFromRes, removeDataKeys, removeNullDeep } from 'src/utils/helper';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getBasisDataKostenKategorie,
	getKostenErlauterung,
} from '../../../../application-helper-function/AppHelperfunctions';
import EinnahmenHinweisGlobal from '../../../global-structure/einnahmen-hinweis/content/EinnahmenHinweisGlobal';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

const KostenPositionAntragMobilitaetsplaene: FC<{ kostenPosition: string; kostenArt: string; hasComment?: boolean }> = ({
	kostenPosition,
	kostenArt,
	hasComment,
}) => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const [kostenKategorie, setKostenKategorie] = useState([]);

	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const handleAddSachkosten = async () => {
		let appCopy = cloneDeep(application);

		const data = getBasisDataKostenKategorie(
			appCopy,
			kostenKategorie, // All kostenkategorie for kostenArt, to find default Kostenkategorie id
			KOSTENTRAEGER.Antragsteller,
			get(application, `${P.Antragstellende_Organisation.path}.id`),
			kostenPosition,
			kostenArt,
		);
		set(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.path,
				[`${get(application, P.Foerderantrag_Kostenpositions.path, []).length}`],
				['Foerderantrag_Kostenpositions'],
			),
			{ attributes: data },
		);
		saveApplication(false, appCopy);
	};
	const handleDeleteSachKosten = async (id: number) => {
		// autofold/fold_next

		try {
			let appcopy = cloneDeep(application);
			const allKostenposition = get(appcopy, P.Foerderantrag_Kostenpositions.path, []);
			set(
				appcopy,
				P.Foerderantrag_Kostenpositions.path,
				allKostenposition.filter((item: any) => item.id !== id),
			);
			let res = await DeleteRecord(APIS.Kostenposition, id);
			if (res) {
				saveApplication(false, appcopy);
			}
		} catch (err: any) {
			console.error('ERROR: Deleting Personalkosten', err);
		}
	};

	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = withKostenkategorieEinsatzbereichFilter(
					{
						Allgemein_Kostenposition: kostenPosition,
						Allgemein_Kostenart_Finanzierung: kostenArt,
						Allgemein_Antragsformular: {
							$contains: get(application, P.Allgemein_Antragsformular.path),
						},
						Allgemein_Aktiv: { $eq: true },
					},
					APIS.Antrag,
				);
				let res = await GetRecords(APIS.Kostenkategorie, [], filter);
				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data', []))));
			} catch (err: any) {
				console.error('ERROR: FEtching Kosten kategorie ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [kostenPosition, kostenArt]);
	return (
		<>
			<ApplicationHeading title={enumT(kostenArt)} description={PLATZHALTER_TEXT} />
			{kostenPosition === KOSTEN_POSITION.Einnahme && <EinnahmenHinweisGlobal kostentraeger={KOSTENTRAEGER.Antragsteller} />}
			{/* eslint-disable-next-line array-callback-return*/}
			{get(application, P.Foerderantrag_Kostenpositions.path, []).map((eachKP: any, i: number) => {
				if (
					get(eachKP, KP_P.Allgemein_Kostenposition.path) === kostenPosition &&
					get(eachKP, KP_P.Allgemein_Kostenart_Finanzierung.path) === kostenArt
				) {
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle={`${enumT(kostenArt)} - ${get(eachKP, KP_P.Allgemein_Bezeichnung.path, '')}`}
							onDelete={() => handleDeleteSachKosten(get(eachKP, 'id'))}
							showDeleteButton={!updatedReadOnly}
							hasComment={checkIfSpecificKostenPositionHasComment(readOnly, eachKP)}
						>
							<PruefAssistenz
								statusPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Pruefstatus.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								hinweisPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Hinweis_Fuer_Antragsteller.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								ueberarbeitetAmPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								erledigtPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								formStruc={mapKosten(PruefAssistenzStruc(), i)}
							/>

							<MUIAlert
								title={ERLAUTERUNG_IN_KOSTEN_TITLE}
								message={getKostenErlauterung(kostenKategorie, get(eachKP, KP_P.Allgemein_Kostenkategorie.path))}
							/>

							<Grid2 spacing={6} container>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapKosten(formStrucGeneral(kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
										size='small'
									/>
								</Grid2>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapKosten(kostenProJahrStruc(application, i), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
									/>
								</Grid2>
							</Grid2>
						</MUIAccordionComponent>
					);
				}
			})}
			<Button sx={{ mt: '2rem', maxWidth: 'fit-content' }} endIcon={<AddIcon />} disabled={updatedReadOnly} onClick={handleAddSachkosten}>
				{enumT(kostenArt)} hinzufügen
			</Button>
		</>
	);
};

export default KostenPositionAntragMobilitaetsplaene;

const PruefAssistenzStruc = () => {
	return [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
};
const formStrucGeneral = (kostenKategorie?: any[]) => {
	const kategorieOptions = kostenKategorie || [];
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kostenkategorie,
					type: 'singleSelect',
					options: getOptionsFromRes(kategorieOptions, 'Allgemein_Bezeichnung'),
				},
				P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const kostenProJahrStruc = (application: any, i: number) => [
	{
		fields: [
			{
				...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr,
				fieldProps: { Zelle_2: { format: 'currency' } },
				disabledColumns: ['Zelle_1'],
				type: 'componentTable',
				tableLabel: 'Ausgaben pro Jahr',
				maxLevel: get(application, P.Allgemein_Projektdauerin_Jahren.path),
				hideDeleteButton: true,
				sumRow: [
					{
						id: 'pinnedRow',
						Zelle_1: 'Gesamt',
						Zelle_2: get(
							application,
							addIndexesToPath(
								P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
								[`${i}`],
								['Foerderantrag_Kostenpositions'],
							),
						),
					},
				],
			},
		],
		userProps: { columnToDivide: 1 },
	},
];

const mapKosten = (formStruc: FormStrucItem[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				return {
					...value,
					path: addIndexesToPath(get(value, 'path', ''), [`${index}`], ['Foerderantrag_Kostenpositions']),
				};
			}),
		};
	});
	return result;
};
export const getFormStrucKostenPositionAntragMobilitaetsplaene = (application: any, kostenPosition: string, kostenArt: string) => {
	let result: FormStrucItem[] = [];

	get(application, P.Foerderantrag_Kostenpositions.path, []).forEach((eachKP: any, i: number) => {
		if (
			get(eachKP, KP_P.Allgemein_Kostenposition.path) === kostenPosition &&
			get(eachKP, KP_P.Allgemein_Kostenart_Finanzierung.path) === kostenArt
		) {
			const isHinweisFieldRequired = checkIfPruefAssitenzNeedsToValidate(eachKP, KP_P.Pruefung_Pruefstatus.path, KP_P.Pruefung_Erledigt.path);
			const formStrucGeneralWithIndex = mapKosten(formStrucGeneral(), i);
			const formStrucCTWithIndex = getFormStrucComponentTable(application, mapKosten(kostenProJahrStruc(application, i), i));

			if (isHinweisFieldRequired) {
				result = concat(mapKosten(PruefAssistenzStruc(), i), result, formStrucGeneralWithIndex, formStrucCTWithIndex);
			} else {
				result = concat(result, formStrucGeneralWithIndex, formStrucCTWithIndex);
			}
		}
	});

	return result;
};
